import React from 'react';
import { Skeleton } from 'antd';

const TeacherSkeleton = () => (
  <div className="flex h-40 flex-col items-center justify-center gap-y-1 rounded-lg bg-white">
    <Skeleton.Avatar size={48} active />

    <Skeleton.Node className="!w-26 !h-3 !rounded-lg" active />
    <Skeleton.Node className="!w-19 !h-2 !rounded-lg" active />
  </div>
);

export default TeacherSkeleton;
